module.exports = __webpack_public_path__ + "img/whatsapp_logo_1.f49b30cc.svg";